import type { Identifier } from "ra-core";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

/** Parámetro de la URL con la ficha abierta en la ventana (`?ficha=123`). */
export const PARAMETRO_FICHA = "ficha";
/**
 * Proyecto en foco dentro de la ficha (`&proyecto=45`), cuando se abre desde una tarjeta
 * que no es el proyecto principal del negocio (p. ej. un proyecto de Clientes de un cliente
 * que tiene también una compra nueva en Ventas).
 */
export const PARAMETRO_PROYECTO = "proyecto";

export type EstadoVentana = { ventanaFicha?: boolean } | null;

/** Abre la ficha del negocio `id` en la ventana (VentanaFicha), sobre la pantalla actual. */
export const useAbrirFicha = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(
    (id: Identifier, proyecto?: Identifier | null) => {
      const params = new URLSearchParams(location.search);
      params.set(PARAMETRO_FICHA, String(id));
      if (proyecto != null) params.set(PARAMETRO_PROYECTO, String(proyecto));
      else params.delete(PARAMETRO_PROYECTO);
      navigate(
        { pathname: location.pathname, search: `?${params.toString()}` },
        { state: { ventanaFicha: true } satisfies EstadoVentana },
      );
    },
    [navigate, location.pathname, location.search],
  );
};
